import { Component, OnInit } from '@angular/core';
import * as AOS from 'aos';
import {Title } from "@angular/platform-browser";

@Component({
  selector: 'app-safetyinspections',
  templateUrl: './safetyinspections.component.html',
  styleUrls: ['./safetyinspections.component.css']
})
export class SafetyinspectionsComponent implements OnInit {

  constructor(
    private titleService: Title,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle("Safety Inspections - SFI Compliance, Inc");
    AOS.init();
  }

}
